import { type ReactElement } from 'react';
import clsx from 'clsx';
import { TdsIcon } from '@scania/tegel-react';
import { NotAvailable } from '../../../NotAvailable';
import styles from './style.module.scss';
import PulseIcon from './PulseIcon';
import EngineIcon from './EngineIcon';
import BatteryIcon from './BatteryIcon';

type CustomIconName = 'pulse' | 'engine' | 'battery';

interface RowProperties {
  readonly iconName: string;
  readonly prefix?: string;
  readonly value?: string | number | null;
  readonly suffix?: string;
}

const customIcons: Record<CustomIconName, () => ReactElement> = {
  pulse: PulseIcon,
  engine: EngineIcon,
  battery: BatteryIcon,
};

const isCustomIconName = (name: string): name is CustomIconName =>
  name === 'pulse' || name === 'engine' || name === 'battery';

const Row = ({ iconName, prefix, value, suffix }: RowProperties): ReactElement => {
  let icon: ReactElement;

  if (isCustomIconName(iconName)) {
    const CustomIcon = customIcons[iconName];
    icon = <CustomIcon />;
  } else {
    icon = <TdsIcon name={iconName} size="24px" />;
  }

  const hasValue = value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '');
  const displayValue = hasValue ? value : <NotAvailable />;

  return (
    <div className={clsx(styles.container, { [styles['not-available']]: !hasValue })}>
      {icon}
      {prefix}
      {displayValue}
      {hasValue && suffix}
    </div>
  );
};

export default Row;
